import { ITypedReduxAction } from '../../types/redux';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export enum ECpdActionTypes {
  SetCpdModalOpen = 'cpd/set_cpd_modal_open',
}

export type TCpdModalOpen = ITypedReduxAction<ECpdActionTypes.SetCpdModalOpen, boolean>;

export type TCpdModalAction = TCpdModalOpen;

export const setCpdModalOpen = actionGenerator<ECpdActionTypes.SetCpdModalOpen, boolean>(
  ECpdActionTypes.SetCpdModalOpen,
);
